import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Lines from "../images/lines.png";
import { post } from "aws-amplify/api";

const DevNewsForm = ({ signUpFormData }) => {
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const { checkbox, heading, input, title, cta_text } = signUpFormData;
  const theme = useTheme();

  useEffect(() => {
    let timerId = setTimeout(() => setMessage(""), 4000);
    return () => clearTimeout(timerId);
  }, [message]);

  const onSubmit = async (event) => {
    setLoader(true);

    event.preventDefault();
    const form = event.target;

    const inputNames = input.map(({ name }) => name);
    const checkboxNames = checkbox.map(({ name }) => name);

    const fields = inputNames.map((item) => ({
      name: item,
      value: event.target[item]["value"],
    }));

    const options = checkboxNames.map((item) => ({
      name: item,
      value: event.target[item]["checked"],
    }));

    try {
      await post({
        apiName: "community",
        path: "/newsletters",
        options: {
          body: { fields, options },
        },
      }).response;

      setMessage("Thanks for subscribing!");
      form.reset();
    } catch (error) {
      setMessage("Something went wrong...");
    }

    setLoader(false);
  };

  return (
    <Stack
      sx={{
        borderRadius: "42px",
        background: `url("${Lines}") ${theme.palette.primary.dark}`,
        backgroundSize: "cover",
        py: "60px",
        px: {
          xs: "27px",
          sm: "120px",
          md: "180px",
          lg: 0,
        },
        alignItems: { lg: "center" },
      }}
    >
      <Stack
        component="form"
        onSubmit={onSubmit}
        sx={{
          maxWidth: "917px",
          alignItems: { lg: "center" },
        }}
      >
        <Box
          dangerouslySetInnerHTML={{ __html: title.html }}
          sx={{
            maxWidth: "580px",
            alignSelf: "center",

            "&>h1": {
              fontFamily: "Nunito Sans",
              fontWeight: 900,
              fontSize: { xs: "26px", sm: "36px" },
              lineHeight: "1.2",
              color: "#ffffff",
              textAlign: "center",
              marginBottom: "20px",
              marginTop: "0px",
            },
          }}
        />

        {heading && heading.html ? (
          <Box
            dangerouslySetInnerHTML={{ __html: heading.html }}
            sx={{
              "&>p": {
                fontFamily: "Nunito Sans",
                fontWeight: 900,
                fontSize: "14px",
                lineHeight: 1.2,
                color: "white",
                margin: "0px 0px 11px",
              },
            }}
          />
        ) : null}

        <Stack direction={{ lg: "row" }} gap={"10px"}>
          {input.map(({ name, required, text, type }) => (
            <Box
              component="input"
              placeholder={text}
              type={type}
              name={name}
              required={required}
              key={name}
              sx={{
                fontFamily: "Nunito Sans",
                height: "58px",
                borderRadius: "10px",
                fontSize: "16px",
                lineHeight: 1.05,
                color: theme.palette.secondary.dark,
                paddingLeft: "21px",
                paddingRight: "21px",
                border: "none",
                outline: "none",
                "&:focus": {
                  border: "none",
                },
              }}
            />
          ))}

          {loader ? (
            <Stack
              sx={{
                width: "200px",
                alignItems: "center",
              }}
            >
              <CircularProgress sx={{ color: "white" }} />
            </Stack>
          ) : (
            <Box
              component="button"
              type="submit"
              sx={{
                textTransform: "uppercase",
                fontFamily: "Nunito Sans",
                fontSize: "16px",
                fontWeight: 800,
                lineHeight: 1.05,
                textAlign: "center",
                color: "white",
                padding: "20px 52px 19px",
                backgroundColor: "transparent",
                borderRadius: "10px",
                border: "solid 2px white",
                cursor: "pointer",
                outline: "none",
                alignSelf: { xs: "start", lg: "inherit" },
                "&:disabled": {
                  backgroundColor: "#e7e7ef",
                },
                "&:active": {
                  borderColor: "transparent",
                  backgroundColor: theme.palette.primary.main,
                },
              }}
            >
              {cta_text.text}
            </Box>
          )}
        </Stack>

        <Typography
          variant="caption"
          sx={{
            color: theme.palette.accent.main,
            margin: "9px 25px 0 35px",
            fontFamily: "Nunito Sans",
            fontSize: "13px",
            fontWeight: "bold",
            lineHeight: 1.29,
            textAlign: "end",
            height: "15px",
            alignSelf: "stretch",
          }}
        >
          {message}
        </Typography>

        {checkbox.map(({ name, required, text: { html } }) => (
          <Stack
            key={name}
            direction="row"
            sx={{ alignItems: "start", alignSelf: "start" }}
          >
            <Box
              component="input"
              type="checkbox"
              name={name}
              required={required}
              sx={{
                width: "17px",
                height: "17px",
                minWidth: "17px",
                minHeight: "17px",
                border: "solid 1px #e8e8e8",
                borderRadius: "4px",
                margin: "0px",
              }}
            />

            <Box
              dangerouslySetInnerHTML={{
                __html: html,
              }}
              sx={{
                maxWidth: "660px",
                "&>p": {
                  fontFamily: "Nunito Sans",
                  fontSize: "14px",
                  lineHeight: 1.56,
                  color: "white",
                  margin: "0px 0px 0px 10px",
                  "&>a": {
                    color: theme.palette.accent.main,
                    textDecoration: "none",
                  },
                },
              }}
            />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default DevNewsForm;
